/**
 * Created by mykurisu on 2017/6/12.
 */
import React, {Component} from 'react'
import {connect} from 'react-redux'
import LecturerRecord from './LectureLecturersRecord'
import {PanelBody} from 'react-weui'

import '../../styles/lecture/LectureLecturers.css'

class LectureLecturers extends Component {
    constructor() {
        super();
        this.state = {
            showMore: false
        };
        this.handleShowmore = this.handleShowmore.bind(this);
    }

    handleShowmore() {
        this.setState({
            showMore: !this.state.showMore
        })
    }

    render() {
        return (
            <div className={!this.props.description ? 'lecturers-container lecturers-container-first' : 'lecturers-container'}>
                <div className="lecturers-title">
                    <p>讲师介绍</p>
                </div>
                {this.props.lecturers.length > 3 ?
                    <div className="lecturelectures_content">
                        <PanelBody>
                            {this.state.showMore ?
                                this.props.lecturers.map((lecture, i) =>
                                    <LecturerRecord content={lecture} key={lecture.account.id} index={i}/>)
                                : this.props.lecturers.slice(0, 2).map((lecture, i) =>
                                    <LecturerRecord content={lecture} key={lecture.account.id} index={i}/>)
                            }
                        </PanelBody>
                    </div>
                    :
                    <div className="lecturelectures_content">
                        <PanelBody>
                            {this.props.lecturers.map((lecture, i) =>
                                <LecturerRecord content={lecture} key={lecture.account.id} index={i}/>)
                            }
                        </PanelBody>
                    </div>
                }

                {this.props.lecturers.length > 3 &&
                <p className="lecturelectures_shouqi" onClick={this.handleShowmore}>
                    {this.state.showMore ?
                        <i className="icon iconfont icon-shouqi" style={{color: '#C8C8CD'}}/>
                        :
                        <i className="icon iconfont icon-shouqi-copy" style={{color: '#C8C8CD'}}/>
                    }
                </p>
                }
            </div>
        )
    }
}

export default connect((state) => ({
    lecturers: state.lecture.lecturers,
    description: state.lecture.lecture.description,
}))(LectureLecturers)


// WEBPACK FOOTER //
// ./src/components/lecture/LectureLecturers.js